import type { PaginationRequest } from "@proto/gen/common/v1/common"
import {
  ListSitesRequest,
  type ListSitesRequest as ListSitesRequestType,
} from "@proto/gen/sites/v1/service"
import {
  ListCustomersRequest,
  type ListCustomersRequest as ListCustomersRequestType,
  ListTenantsRequest,
  type ListTenantsRequest as ListTenantsRequestType,
  ListUsersRequest,
  type ListUsersRequest as ListUsersRequestType,
} from "@proto/gen/users/v1/service"

type PaginationParams = Partial<PaginationRequest>

function withPagination(pagination?: PaginationParams): PaginationRequest | undefined {
  if (!pagination) return undefined
  return {
    offset: 0,
    limit: 50,
    ...pagination,
  }
}

/** Build a ListSitesRequest with protobuf defaults (including customerIds: []). */
export function createListSitesRequest(
  params: Partial<Omit<ListSitesRequestType, "pagination">> & { pagination?: PaginationParams } = {}
): ListSitesRequestType {
  const { pagination, ...rest } = params
  return ListSitesRequest.create({
    ...rest,
    pagination: withPagination(pagination),
  })
}

/** Build a ListTenantsRequest with protobuf defaults (status enum, slug). */
export function createListTenantsRequest(
  params: Partial<Omit<ListTenantsRequestType, "pagination">> & {
    pagination?: PaginationParams
  } = {}
): ListTenantsRequestType {
  const { pagination, ...rest } = params
  return ListTenantsRequest.create({
    ...rest,
    pagination: withPagination(pagination),
  })
}

/** Build a ListCustomersRequest with protobuf defaults. */
export function createListCustomersRequest(
  params: Partial<Omit<ListCustomersRequestType, "pagination">> & {
    pagination?: PaginationParams
  } = {}
): ListCustomersRequestType {
  const { pagination, ...rest } = params
  return ListCustomersRequest.create({
    ...rest,
    pagination: withPagination(pagination),
  })
}

/** Build a ListUsersRequest with protobuf defaults. */
export function createListUsersRequest(
  params: Partial<Omit<ListUsersRequestType, "pagination">> & { pagination?: PaginationParams } = {}
): ListUsersRequestType {
  const { pagination, ...rest } = params
  return ListUsersRequest.create({
    ...rest,
    pagination: withPagination(pagination),
  })
}
